import React from 'react'
import styled from 'styled-components'
import { inputStyle } from './Input'

import "react-datepicker/dist/react-datepicker.css";
import "./DateInputStyle.css"

const StyledInput = styled.input`
    ${inputStyle}
    height: 26px;
    width: 120px;

    &.coupons{
      height: 35px;
      width: 100%;
    }
`

export const Date = ({value, modality, index, onChange, ...rest}) => {
   
    const handleChange = (e) => {
        if (onChange) {
            onChange({e, modality, index})
        }
    }

    return (
        <StyledInput
            value={value}
            type="date"
            onChange={handleChange}
            {...rest}
        />
    )
}
